import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Tooltip } from 'primeng/tooltip';

import { BusinessAreaEnum } from 'app/core/enums/generated/BusinessAreaEnum';
import { SecurityService } from 'app/core/security/security.service';
import { QuickNavService } from 'app/shared/navigation/quick-navs/quick-nav/quick-nav.service';
import { SysInvQuickNavComponent } from 'app/shared/navigation/quick-navs/sysInv-quick-nav/sysInv-quick-nav.component';
import { SYS_INV_QUICK_NAV_ROLES, SysInvQuickNavService } from 'app/shared/navigation/quick-navs/sysInv-quick-nav/sysInv-quick-nav.service';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';

/**
 * The Issuance quick-nav search and scanner on the dashboard, so staff reach an order, fulfillment, receiving,
 * return, transfer, PID or serial without first entering Issuance. Reuses {@link SysInvQuickNavComponent} in its
 * embedded form, which drops the popover chrome and the page-wide QR listener.
 *
 * Both quick-nav services are provided here rather than taken from root: the widget keeps its own search mode,
 * new-tab choice and popover state, so it never shares them with the header quick-nav.
 *
 * Gated on the live user, not the saved layout: a cached layout still naming this widget after the user's Issuance
 * access is revoked renders the notice below and never creates the quick-nav (so no inventory fetch either).
 */
@Component({
    selector: 'pcg-issuance-quick-scan-widget'
    , templateUrl: './issuance-quick-scan-widget.component.html'
    , styleUrl: '../resizable-widget/resizable-widget.component.scss'
    , changeDetection: ChangeDetectionStrategy.OnPush
    , providers: [
        SysInvQuickNavService
        , QuickNavService
    ]
    , imports: [
        FormsModule
        , ToggleSwitch
        , Tooltip
        , ResizableWidgetComponent
        , SysInvQuickNavComponent
    ]
})
export class IssuanceQuickScanWidgetComponent {
    private readonly sec = inject(SecurityService);

    /** This widget's own instance (see providers); the header's new-tab switch writes it, the quick-nav follows it. */
    readonly sysInvQuickNavService = inject(SysInvQuickNavService);

    canAccess = computed(() => !!this.sec.hasModuleAccess([BusinessAreaEnum.SysInv], SYS_INV_QUICK_NAV_ROLES));
}
